import { Fragment, useState } from 'react';
import { Dropdown, DropdownMenu, UncontrolledTooltip } from 'reactstrap';
import styled from 'styled-components';
import DropdownOption from './DropdownOption';
import IconButton from './IconButton';

export const EllipsisText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WrappedText = styled.div`
  white-space: normal;
  text-align: start;
`;

export const StyledMenu = styled(DropdownMenu)`
  overflow-y: auto;
  ${({ $inModal }) => ($inModal ? 'z-index: 1050;' : '')}
  max-height: ${({ $maxMenuHeight }) =>
    $maxMenuHeight ? `${$maxMenuHeight}` : '100vh'};
  max-width: 100vw;
  ${({ $fontSmall }) => ($fontSmall ? 'font-size: 1em' : '')}
`;

const DropdownButton = styled(
  ({
    options,
    setOption,
    selectedOption,
    placeholder = 'Select...',
    showOverflow,
    inModal, // Set the z-index of the dropdown menu for showing over a modal
    maxMenuHeight,
    menuFontSmall,
    showCheckmark,
    className,
    size = 'sm',
    ...props
  }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((open) => !open);

    const TextElement = showOverflow ? WrappedText : EllipsisText;

    return (
      <Dropdown
        isOpen={dropdownOpen}
        toggle={toggle}
        className={`d-flex ${showOverflow ? '' : 'overflow-hidden'}`}
      >
        <IconButton
          toggle
          size={size === 'med' ? undefined : size}
          className={className}
          {...props}
        >
          <TextElement>{selectedOption || placeholder}</TextElement>
        </IconButton>
        {/* The container and flip props are needed to correctly position the open menu
          within the oveflow: scroll table and prevent clipping. */}
        <StyledMenu
          container="body"
          flip={false}
          modifiers={{ preventOverflow: { boundariesElement: 'viewport' } }}
          $inModal={inModal}
          $maxMenuHeight={maxMenuHeight}
          $fontSmall={menuFontSmall}
        >
          {options.map((option) => {
            if (option.overrideComponent) {
              return option.overrideComponent;
            }
            const id = `option-${
              option.key || option.name.replaceAll(' ', '')
            }`;
            return (
              <Fragment key={option.key || option.name}>
                <div id={id}>
                  <DropdownOption
                    option={option}
                    setOption={setOption}
                    selectedOption={selectedOption}
                    showCheckmark={showCheckmark}
                  />
                </div>
                {option.tooltip && (
                  <UncontrolledTooltip
                    key={option.name}
                    placement="bottom"
                    target={id}
                    fade={false}
                  >
                    {option.tooltip}
                  </UncontrolledTooltip>
                )}
              </Fragment>
            );
          })}
        </StyledMenu>
      </Dropdown>
    );
  },
)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export default DropdownButton;
